/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { IntegrationCategoryId } from './integrationCategoryId';

export interface IntegrationCategory {
  id: IntegrationCategoryId;
  label: string;
}
